module.exports = __webpack_public_path__ + "img/xi_token_icon_v0.1-48.d95445d6.png";